// extracted by mini-css-extract-plugin
export default {"children":"vPkocwf8TIDxyzWU4tVJ","dismissLabel":"coGJc1fYT3oSBF4TFy05"};